module.exports = __webpack_public_path__ + "static/media/6.bc451084.png";